import React from 'react';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd'
import { getFirstImage } from '../GenericProductItem';
import { ProductAttributeEdit } from '../../pages/attributes/productAttributeEdit'
import LabelText from '../LabelText';
import { getDisplayCategory } from './itemDecorator';

function OmitEmptyLabelText(props) {
    const { label, value } = props || {}
    return value ? <LabelText className='mt-1' label={label} value={value} /> : null
}

function OmitEmptyLabelNumber(props) {
    const { label, value } = props || {}
    const dv = (typeof value === 'number' && !Number.isNaN(value) && !Number.isInteger(value)) ? value.toFixed(3) : value
    return dv ? <LabelText className='mt-1' label={label} value={dv} capFirstLetter={false} /> : null
}


function TipsLabel(props) {
    const { label, icon, title, content } = props
    return (
        <span>
            <strong>{label}</strong>
            <strong>: </strong>
            <Popover placement="right" title={title} content={content}>
                {icon}
            </Popover>
            <span> </span>
        </span>
    )
}

function PlainJson(props) {
    const { content } = props
    return (
        <div style={{ width: '220px' }}>
            {
                !content ? null : Object.keys(content).map(key => {
                    return (
                        <div style={{ wordWrap: 'break-word' }}>
                            <span>{key}: </span>
                            <span>{content[key]}</span>
                        </div>
                    )
                })
            }
        </div>
    )
}

const ProductItem = ({ product, expand, attributes }: {
    product: any
    expand: boolean
    attributes?: string[] | null
}) => {
    const {
        id,
        name,
        nameCN,
        images,
        category,
        categoryIds,
        labels,
        details,
        badges,
        brandId,
        displayBrand,
        originalPriceTag,
        priceTag,
        priceTagCN,
        inventoryStatus,
    } = product || {}
    const prodImg = getFirstImage(images)
    return (
        <div style={{ marginBottom: '15px', marginRight:'12px', width: '236px'}}>
            <div className="card">
                <Link to={ `/discover/${id}` } target="_blank">
                    <img
                        className="card-img-top product-img"
                        src={ prodImg?.url || '' }
                        width={ prodImg?.width }
                        height={ prodImg?.height }
                        alt="card img cap"
                    />
                </Link>
                <div style={{ padding: '15px', fontSize: '11px' }}>
                    <div className=" txt-black">
                        <strong>
                            <span className={ (brandId && brandId.length) > 0 ? "txt-black" : "txt-gray" }>{ displayBrand } / </span>
                            {originalPriceTag && <span><del className="txt-gray" style={{ fontSize: '10px' }}>{ originalPriceTag }</del> </span>}
                            <span className={ originalPriceTag ? 'txt-highlight' : 'txt-black' }>{ priceTag }</span>
                            <span style={{ fontSize: '10px' }}> { priceTagCN }</span>
                        </strong>
                    </div>
                    <OmitEmptyLabelText label='Name' value={nameCN || name} />
                    {
                        expand && 
                        <>
                            <OmitEmptyLabelText label='NameEN' value={nameCN && name} />
                        </>
                    }
                    <OmitEmptyLabelText label='ID' value={id} />
                    <OmitEmptyLabelText label='Category' value={getDisplayCategory(categoryIds)} />
                    <OmitEmptyLabelText label='Inventory' value={inventoryStatus} />
                    {
                        expand && 
                        <>
                            <OmitEmptyLabelText label='CategoryIds' value={categoryIds?.join(',')} />
                            <OmitEmptyLabelText label='Categories' value={category} />
                            <OmitEmptyLabelText label='Labels' value={labels?.join(', ')} />
                            <OmitEmptyLabelText label='Badges' value={badges?.map(b => b.text)?.join(' | ')} />
                            <OmitEmptyLabelNumber label={
                                <TipsLabel
                                    label="Score"
                                    title="Metrics"
                                    content={<PlainJson content={Object.keys(details?.metrics).sort().reduce((r, k) => (r[k] = details?.metrics[k], r), {})} />}
                                    icon={<QuestionCircleOutlined style={{ color: '#1377cc', cursor: 'pointer' }} />}
                                />
                            } value={details?.metrics?.rankScore} />
                            <OmitEmptyLabelText label='Keywords' value={details?.productKeywords?.join(', ')} />
                            <OmitEmptyLabelNumber label='esScore' value={details?.score} />
                            <OmitEmptyLabelNumber label='ppmIndex' value={details?.metrics?.ppmIndex} />
                            <OmitEmptyLabelNumber label='adjustedPPM' value={details?.metrics?.adjustScore} />
                            <OmitEmptyLabelNumber label='totalImp' value={details?.metrics?.totalImp} />
                            <OmitEmptyLabelNumber label='Boost' value={details?.metrics?.boost} />
                            <OmitEmptyLabelText
                                label={
                                    <TipsLabel
                                        label="Attributes"
                                        content={<ProductAttributeEdit id={id} />}
                                        icon={<InfoCircleOutlined style={{ color: '#1377cc', cursor: 'pointer' }} />}
                                    />
                                }
                                value={attributes?.join(', ')}
                            />
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default ProductItem;
